import {
	CircleDollarSign,
	Infinity as InfinityIcon,
	type LucideIcon,
} from "lucide-react";
import type { ObjPathProxy } from "ts-object-path";
import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

type RentDrawdownOption = {
	value: RentDrawdownMode;
	icon: LucideIcon;
	labelKey: ObjPathProxy<MyPlannResourceDictionary, string>;
};

const RENT_DRAWDOWN_OPTION_CONFIG = {
	[RentDrawdownMode.ToZero]: {
		icon: CircleDollarSign,
		labelKey: Resources.Goals.Form.Pension.Drawdown.toZeroLabel,
	},
	[RentDrawdownMode.Perpetual]: {
		icon: InfinityIcon,
		labelKey: Resources.Goals.Form.Pension.Drawdown.perpetualLabel,
	},
} satisfies Record<RentDrawdownMode, Omit<RentDrawdownOption, "value">>;

export const RENT_DRAWDOWN_OPTIONS: ReadonlyArray<RentDrawdownOption> =
	Object.values(RentDrawdownMode).map((value) => ({
		value,
		...RENT_DRAWDOWN_OPTION_CONFIG[value],
	}));
